import React from 'react';
import { List } from 'immutable';
import ContentSlider from '../../../components/ContentSlider';

const ParagraphContentSlider = ({ entity }) => {
  const entities = entity.get('field_paragraphs', List());
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;

  if (entities.count() === 0) return null;

  return (
    <div id={paragraphKey} className="Paragraph ParagraphContentSlider">
      <ContentSlider entities={entities} />
    </div>
  );
};

export default ParagraphContentSlider;
